import React from "react"
import { OrderShippingIngrid } from "lib/types/generated/graphql-types"
import { ReactComponent as IngridLogo } from "images/providers/ingrid-logo.svg"
import CopyButton from "components/Ui/CopyButton"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import { Container, CopyWrapper, Row, Title } from "./Styled"

type Props = {
  shippingIngrid: OrderShippingIngrid | undefined
}

const IngridDetails = ({ shippingIngrid }: Props) => {
  if (!shippingIngrid?.deliveries) return null

  const ingridDelivery = shippingIngrid.deliveries.length ? shippingIngrid.deliveries[0] : {}

  return (
    <>
      <Title $logoMargin={"0 0.8rem 0"}>
        <IngridLogo /> details
      </Title>
      <Container>
        <Row>
          <CopyWrapper>
            <ListEntry label={"Reference"} value={shippingIngrid?.reference} />{" "}
            <CopyButton string={shippingIngrid?.reference} />
          </CopyWrapper>
          <ListEntry label={"Delivery type"} value={ingridDelivery?.deliveryType ?? "-"} />
        </Row>
        <Row>
          <ListEntry label={"Transport ID"} value={ingridDelivery?.tosId ?? "-"} />
          <ListEntry label={"Carrier product ID"} value={ingridDelivery?.carrierProductId ?? "-"} />
        </Row>
        <Row>
          <ListEntry label={"Name"} value={ingridDelivery?.deliveryAddress?.name ?? "-"} />
          <ListEntry
            label={"Address"}
            value={
              ingridDelivery.deliveryAddress?.addressLines
                ? ingridDelivery?.deliveryAddress?.addressLines[0]
                : "-"
            }
          />
        </Row>
        <Row>
          <ListEntry label={"City"} value={ingridDelivery?.deliveryAddress?.city ?? "-"} />
          <ListEntry
            label={"Postal code"}
            value={ingridDelivery?.deliveryAddress?.postalCode ?? "-"}
          />
        </Row>
      </Container>
    </>
  )
}

export default IngridDetails
